import React from 'react';
import classNames from 'classnames';
import intl from 'react-intl-universal';
import './ReturnIcon.scss';

interface ReturnIcon {
  onClick?: () => void;
}
// 注意，ReturnIcon不负责外层具体的样式，需要各种定位请在外层处理
const ReturnIcon = (props: ReturnIcon) => {
  const loc = intl.getInitOptions().currentLocale;
  const cls = classNames('return-icon', { en: loc !== 'zh-CN' });
  return <div className={cls} onClick={props.onClick} />;
};
export default ReturnIcon;
